module.exports = __webpack_public_path__ + "static/media/barcodeImage_pdf417.1fecc9a4.svg";